import { useAdminRegistryTelemetry } from '@apps/registry/admin/AdminRegistry.telemetry';
import { useHistory, useTranslation } from '@shared/core';
import { useButtonClickHandler, useNativeState } from '@shared/core/native';
import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { maybeApplyCallback } from '@shared/utils/maybeApplyCallback';
import { withWindow } from '@shared/utils/withWindow';
import { routePaths } from '../Registry.routes';

type UseInstallBrowserButtonPropsArgs = Readonly<{
  eventId?: string;
  website?: string | null;
}>;

export const useInstallBrowserButtonProps = (args: UseInstallBrowserButtonPropsArgs) => {
  const { eventId = '', website } = args;
  const { push } = useHistory();
  const { t2 } = useTranslation('createRegistry');
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } });
  const { isNative } = useNativeState();
  const { clickInstallBrowserButton, joyButtonDialogLoad } = useAdminRegistryTelemetry();

  const { buttonText } = t2('experiments', 'installBrowserButton')[isNative ? 'native' : isMobile ? 'mobile' : 'default'];

  const onClick = useButtonClickHandler({
    buttonId: 'SetupAddToJoyButton',
    handler: e => {
      const clickSection = (e.currentTarget as HTMLElement).dataset.section;
      clickInstallBrowserButton(buttonText, eventId, clickSection);

      if (isMobile) {
        withWindow(global => global.open('https://py46n.app.goo.gl/getjoybookmarklet', '_blank'));
        return;
      }

      joyButtonDialogLoad.enter(eventId, 'install');
      const isPublicShop = window.location.pathname.includes('/shop') && !window.location.pathname.includes('/edit');
      if (isPublicShop && !!website) {
        withWindow(window => window.open(`/${website}/edit/registry/${routePaths.quickAdd.path}`, '_self'));
      } else {
        push(routePaths.quickAdd.path);
      }
    }
  });

  return {
    onClick: maybeApplyCallback(!!eventId, onClick),
    children: buttonText
  } as const;
};
